import { render, staticRenderFns } from "./InAppDeliveryMode.vue?vue&type=template&id=65f61f2c"
import script from "./InAppDeliveryMode.vue?vue&type=script&lang=js"
export * from "./InAppDeliveryMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports